<template>
  <div :class="`custom-toast-notification text-white d-flex custom-tost ${props.type}-bg`">
    <slot />
    <v-icon
      v-if="props.type != NotificationType.Info"
      size="18"
      @click="removeNotification(index)"
      class="pr-6 ml-auto"
    >
      mdi-close
    </v-icon>
  </div>
</template>
<script setup lang="ts">
import useGlobalStore from '@/stores/modules/global'
import { defineProps, onMounted } from 'vue'
import NotificationType from '@/enum/NotificationType'

const props = defineProps(['type', 'timeout', 'id', 'index', 'callback'])
const globalStore = useGlobalStore()

const removeNotification = (inx: number) => {
  globalStore.toastNotifications =
    globalStore.toastNotifications?.filter((_, index) => index !== inx) ?? null
}

onMounted(() => {
  const autoRemoveTimeout = props.timeout ?? 2000
  if (!(props.type == NotificationType.Info && props.callback)) {
    setTimeout(() => {
      removeNotification(props.index)
    }, autoRemoveTimeout)
  }
})
</script>
<style lang="scss">
.custom-tost {
  width: 400px;
  min-height: 60px;
  align-items: center;
  padding-left: 24px;
  padding-top: 12px;
  padding-bottom: 12px;
}
</style>
